import script from "./SideMenuInfoTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuInfoTab.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuInfoTab.vue?vue&type=style&index=0&id=588dd063&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-588dd063"]])

export default __exports__